export const DEMO_DATASETS = [
  {
    id: 'ecommerce',
    name: 'E-commerce sales',
    description: 'Orders, revenue, channels, and regional performance.',
    path: '/sample-data/ecommerce-sales.csv',
    filename: 'ecommerce-sales.csv',
    rows: 24,
    columns: 10,
    questions: [
      'What is total revenue by region?',
      'Which product has the highest average order value?',
      'How many orders came from each sales channel?',
      'Show monthly revenue trends.'
    ]
  },
  {
    id: 'saas',
    name: 'SaaS subscriptions',
    description: 'MRR, churn, upgrades, and plan mix for a SaaS product.',
    path: '/sample-data/saas-subscriptions.csv',
    filename: 'saas-subscriptions.csv',
    rows: 18,
    columns: 9,
    questions: [
      'How has MRR changed month over month?',
      'Which plan has the highest churn?',
      'What is the average revenue per account?',
      'How many upgrades happened last quarter?'
    ]
  },
  {
    id: 'support',
    name: 'Support tickets',
    description: 'Ticket volume, resolution time, and CSAT trends.',
    path: '/sample-data/support-tickets.csv',
    filename: 'support-tickets.csv',
    rows: 22,
    columns: 8,
    questions: [
      'What is average resolution time by priority?',
      'Which categories drive the most tickets?',
      'How does CSAT vary by channel?',
      'Show ticket volume by week.'
    ]
  }
];
